import React from 'react';
import {Typography} from '@mui/material';

import {translations} from 'presentation/translations-new';

const {text, text2} = translations['pt-br'].privateFlow.therapyBooking.alerts.allScheduled;

export function AllScheduledDescription() {
	return (
		<Typography textAlign="center">
			{text}
			<br />
			<br />
			{text2}
		</Typography>
	);
}
